import React from 'react';

import { Button, Table } from 'semantic-ui-react';

const PositionTable = (props) => {
	const position = props.position;

	return (
		<Table basic="very" celled collapsing>
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell>Пара</Table.HeaderCell>
					<Table.HeaderCell>Тип</Table.HeaderCell>
					<Table.HeaderCell>Цена открытия</Table.HeaderCell>
					<Table.HeaderCell>Тек.цена</Table.HeaderCell>
					<Table.HeaderCell>Кол-во</Table.HeaderCell>
					<Table.HeaderCell>Объем</Table.HeaderCell>
					<Table.HeaderCell>Плечо</Table.HeaderCell>
					<Table.HeaderCell>P&L</Table.HeaderCell>
					<Table.HeaderCell>ТП</Table.HeaderCell>
					<Table.HeaderCell>СЛ</Table.HeaderCell>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				<Table.Row key={`position_side_row`}>
					<Table.Cell key={`position_symbol_cell_value`}>
						{position.symbol}
					</Table.Cell>
					<Table.Cell key={`position_side_cell_value`}>
						{position.side}
					</Table.Cell>
					<Table.Cell key={`position_avg_cell_value`}>
						$ {position.avgPrice}
					</Table.Cell>
					<Table.Cell key={`position_mark_price_cell_value`}>
						$ {position.markPrice}
					</Table.Cell>
					<Table.Cell key={`position_qty_cell_value`}>
						{position.size}
					</Table.Cell>
					<Table.Cell key={`position_val_cell_value`}>
						{position.positionValue}
					</Table.Cell>
					<Table.Cell key={`position_lev_cell_value`}>
						x {position.leverage}
					</Table.Cell>
					<Table.Cell key={`position_pnl_cell_value`}>
						$ {position.unrealisedPnl} (% {(Number(position.unrealisedPnl) / (Number(position.positionValue) / Number(position.leverage)) * 100).toFixed(2)})
					</Table.Cell>
					<Table.Cell key={`position_tp_cell_value`}>
						$ {position.takeProfit}
					</Table.Cell>
					<Table.Cell key={`position_sl_cell_value`}>
						$ {position.stopLoss}
					</Table.Cell>
				</Table.Row>
			</Table.Body>
		</Table>
	);
};

export default PositionTable;
